import type { ReactNode } from 'react'
import {
  brand,
  brandLogo,
  brandLogoDark,
  brandLogoLight,
  header,
  page,
  panel,
  panelWide,
  subtitle,
  title,
} from './auth.css'

type AuthLayoutProps = {
  title: string
  subtitle: string
  children: ReactNode
  wide?: boolean
}

export function AuthLayout({
  title: titleText,
  subtitle: subtitleText,
  children,
  wide = false,
}: AuthLayoutProps) {
  return (
    <main className={page}>
      <section className={`${panel} ${wide ? panelWide : ''}`}>
        <div className={brand}>
          <img
            className={`${brandLogo} ${brandLogoLight}`}
            src="/brand/logo-full.png"
            alt="VendePay"
          />
          <img
            className={`${brandLogo} ${brandLogoDark}`}
            src="/brand/logo-full-claro.png"
            alt="VendePay"
          />
        </div>
        <div className={header}>
          <h1 className={title}>{titleText}</h1>
          <p className={subtitle}>{subtitleText}</p>
        </div>
        {children}
      </section>
    </main>
  )
}
